'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { createTracker } from 'usage-tracker-public';
import events from '../../events.yaml';
import { ActionTypes } from '../constants/AppConstants';
import LanguageUtil from '../util/LanguageUtil';
var appName = 'WebsiteGrader';
var listenToEvents = [ActionTypes.GRADE_WEBSITE, ActionTypes.WEBSITE_GRADED, ActionTypes.WEBSITE_GRADED_ERROR, ActionTypes.MARKETING_FREE_MODAL_OPENED, ActionTypes.MARKETING_FREE_MODAL_CLOSED, ActionTypes.MARKETING_FREE_MODAL_LINK_CLICKED];

var UsageTracker = /*#__PURE__*/function () {
  function UsageTracker() {
    _classCallCheck(this, UsageTracker);

    this.tracker = createTracker({
      events: events,
      properties: {
        namespace: appName
      },
      lastKnownEventProperties: ['view', 'screen']
    });
  }

  _createClass(UsageTracker, [{
    key: "log",
    value: function log() {
      var eventKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.tracker.track(eventKey, eventProperties);
    }
  }, {
    key: "logView",
    value: function logView(view) {
      var viewProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (view) {
        this.log('pageView', Object.assign({
          screen: view,
          // Capitalize the first letter of the view
          view: view,
          language: LanguageUtil.getPrintUserLanguage()
        }, viewProperties));
      }
    }
  }, {
    key: "logExposure",
    value: function logExposure(treatmentKey, websiteUrl, key, value) {
      this.log('experimentExposure', {
        treatmentKey: treatmentKey,
        websiteUrl: websiteUrl,
        key: key,
        value: value
      });
    }
  }, {
    key: "logAction",
    value: function logAction(data) {
      this.log('genericAction', data);
    }
  }, {
    key: "logStateChange",
    value: function logStateChange(_ref) {
      var routes = _ref.routes;

      if (!routes[1]) {
        return;
      }

      var view = routes[1].name;
      this.logView(view);
    }
  }, {
    key: "logActionChange",
    value: function logActionChange(action) {
      var type = action.type,
          payload = action.payload;
      var resultAction = {
        type: type
      }; // Ignore some events

      if (listenToEvents.indexOf(type) < 0) {
        return;
      }

      if (type === ActionTypes.GRADE_WEBSITE || type === ActionTypes.WEBSITE_GRADED_ERROR) {
        resultAction.website = payload.websiteUrl;
      } else if (type === ActionTypes.WEBSITE_GRADED) {
        resultAction.website = payload.domain;
      }

      this.logAction(resultAction);
    }
  }]);

  return UsageTracker;
}();

export default new UsageTracker();